import ValuesControl from '@components/values-control/values-control.component'
import { ButtonBack, FinancialOperationService, TioPatinhasService } from '@hub/shared'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './history-value.component.scoped.scss'
import './history-value.component.scss'

export interface Amounts {
  value: number
  campaignQuantity: number
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  hideBack?: boolean
  onChange?: (value: any) => any
  onClickBackButton?: () => any
}

export default ({ hideBack, onChange, onClickBackButton }: Props) => {
  const financialOperationService = useMemo(() => new FinancialOperationService(), [])
  const navigate = useNavigate()
  const [t] = useTranslation('historyValue')
  const [hideValue, setHideValue] = useState(true)
  const [state, setState] = useState<Amounts>({ value: 0, campaignQuantity: 0 })

  const getAmounts = useCallback(async () => {
    try {
      // Os status abaixo são os que não serão carregados no Amount
      const response = await financialOperationService.getAmountsReceived([
        'new',
        'pending',
        'analyze',
        'review',
        'readyToPay',
        'withdrawing',
        'canceled',
        'retry',
        'blocked',
        'unblocked',
        'failed',
      ])
      if (response?.uniqueStatus?.length) {
        setState((prevState) => ({
          ...prevState,
          value: response?.totals?.totalGrossValue,
          campaignQuantity: response?.totals?.totalCampaigns,
        }))
      } else {
        setState((prevState) => ({
          ...prevState,
          value: 0,
          campaignQuantity: 0,
        }))
      }
    } catch (err) {
      setState((prevState) => ({
        ...prevState,
        value: 0,
        campaignQuantity: 0,
      }))
    }
  }, [financialOperationService])

  useEffect(() => {
    getAmounts()
  }, [getAmounts])

  const handleChange = useCallback(
    (value: boolean) => {
      setHideValue(value)

      if (onChange && typeof onChange === 'function') {
        onChange(value)
      }
    },
    [onChange]
  )

  const back = () => {
    if (onClickBackButton && typeof onClickBackButton === 'function') {
      onClickBackButton()
    }
  }

  return (
    <section className="history-value">
      <header>
        <div className="back-title">
          {!hideBack ? (
            <ButtonBack onClick={onClickBackButton ? back : undefined} onReferrerFalseUrl="/payments/info" circleLayout />
          ) : null}
          <h5 className="ml-3">{t('title')}</h5>
        </div>
        <ValuesControl valueChange={(value: boolean) => handleChange(value)} />
      </header>
      <p className="value">
        {hideValue ? '••••••' : state.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}
      </p>
      {state.campaignQuantity ? (
        <p dangerouslySetInnerHTML={{ __html: t('quantityText', { campaignQuantity: state.campaignQuantity }) }}></p>
      ) : null}
    </section>
  )
}
